import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    const api = await getAxiosInstance();
    const getParams = (key) => {
      if (params?.[key]) {
        return `${key}=${params[key]}&`;
      } else {
        return "";
      }
    };
    if (method === "get") {
      try {
        const response = await api[method](
          `${endpoint}?${getParams("receipt_id")}${getParams("end")}filter=${
            params?.filter || "all"
          }&${getParams("sort_by")}sort_order=${
            params?.sort_order || "asc"
          }&per_page=${params?.page_size || "10"}&${getParams("search")}page=${
            params?.page || 1
          }&${getParams("process_slug")}`,
          body,
        );
        return { data: response.data };
      } catch (axiosError) {
        let err = axiosError;
        return {
          error: {
            status: err.response?.status,
            data: err.response?.data || err.message,
          },
        };
      }
    } else {
      try {
        const response = await api[method](
          `${endpoint}${getParams("start")}${getParams("end")}${getParams(
            "sort_by",
          )}${getParams("search")}`,
          body,
        );
        return { data: response.data };
      } catch (axiosError) {
        let err = axiosError;
        return {
          error: {
            status: err.response?.status,
            data: err.response?.data || err.message,
          },
        };
      }
    }
  };

export const photoSection = createApi({
  reducerPath: "photoSectionApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    "photoSection",
    "photoSectionRecheck, photoSectionReissue",
    "photoSectionOldCardReissue",
  ],
  endpoints: (builder) => ({
    // form data
    getPhotoSectionTableData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/photo-uploading/designid-list`,
      }),
      providesTags: ["photoSection"],
    }),
    getPhotoSectionRecheckTableData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/photo-uploading/recheck/designid-list`,
      }),
      providesTags: ["photoSectionRecheck"],
    }),
    getPhotoSectionReissueTableData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/photo-uploading/reissue/designid-list`,
      }),
      providesTags: ["photoSectionReissue"],
    }),
    getPhotoSectionOldCardReissueTableData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/photo-uploading/old-certificate/designid-list`,
      }),
      providesTags: ["photoSectionOldCardReissue"],
    }),
    updatePhotoSectionTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-fields/save`,
      }),
      invalidatesTags: ["photoSection"],
    }),
    updatePhotoSectionRecheckTableHeadData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/user-fields/save`,
      }),
      invalidatesTags: ["photoSectionRecheck"],
    }),
    getEmployeeListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/verification/employee-list`,
      }),
    }),
    getCertificateListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/photo-uploading/certificates`,
      }),
    }),
  }),
});

export const {
  useGetPhotoSectionTableDataQuery,
  useGetPhotoSectionRecheckTableDataQuery,
  useUpdatePhotoSectionTableHeadDataMutation,
  useUpdatePhotoSectionRecheckTableHeadDataMutation,
  useGetPhotoSectionReissueTableDataQuery,
  useGetPhotoSectionOldCardReissueTableDataQuery,
  useLazyGetCertificateListDataQuery,
  useLazyGetEmployeeListDataQuery,
} = photoSection;
